import { PendingUsersList } from "./PendingUsersList";

export default PendingUsersList;
